
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

/**
 * 隐藏部分手机号
 * 中间四位转为*
 */
const hidePhoneNumber = (phoneNumber: string) => phoneNumber.substring(0, 3) + '****' + phoneNumber.substring(7)

/**
 * 隐藏部分邮箱
 * 隐藏前两位展示四位*
 */
const hideEmail = (email: string) => {
  const atIndex = email.indexOf('@')
  const prefix = email.substring(0, atIndex)
  const suffix = email.substring(atIndex)
  const hiddenPrefix = prefix.substring(0, 2) + '****'
  return hiddenPrefix + suffix
}

@Observer
@Component({
  components: {}
})
export default class AccountCodeLogin extends Vue {
  @Prop({ required: true }) bindType: 'phone' | 'email'
  @Prop({ required: true }) bindAccount: string | null

  get UserStore() {
    return this.$store.$storeUser
  }

  get options() {
    return {
      validDevice: false,
      phone: this.bindType === 'phone',
      btnText: '登录',
      label: this.bindType === 'phone' ? '手机号' : '邮箱',
      inputInnerText: '请输入四位验证码',
      defaultValue: this.bindAccount,
      isFirstTrigger: true,
      layout: {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 }
      },
      btnCol: { span: 24, offset: 0 }
    }
  }

  async handleSendCode(modal: { device: string }, callback: () => void, closeLockCallback: () => void) {
    try {
      if (this.bindType === 'phone') {
        await this.UserStore.onLoginByPhone(modal.device)
      } else {
        await this.UserStore.onLoginByEmail(modal.device)
      }

      callback()
    } finally {
      closeLockCallback()
    }
  }

  async handleConfirm(modal: { device: string; verifyCode: string }) {
    console.log(modal)

    await this.UserStore.onLogin({ code: modal.verifyCode, itcode: modal.device }, this.bindType === 'phone' ? 'sms_code' : 'email_code')

    this.$msg('登录成功，欢迎你桐学 🎉')
    setTimeout(() => {
      window.location.reload()
    }, 50)
  }

  get hidedAccount() {
    if (this.bindAccount === null) {
      return ''
    }

    return this.bindType === 'phone' ? hidePhoneNumber(this.bindAccount) : hideEmail(this.bindAccount)
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
